import(/* webpackMode: "eager" */ "/app/apps/ats-recruiter/app/(main)/(jobflex)/career/error.tsx");
